const selectError = (state: { error: any }) => state.error;
export {selectError}